import { FC, ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  children: ReactNode | any;
};
export const ClientSidePortalRp: FC<Props> = ({ children }) => {
  const [mounted, setMounted] = useState<boolean>(false);
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setMounted(true);

    if (typeof document !== 'undefined' && document.body) {
      setContainer(document.body);
    }
  }, []);

  if (!mounted || !container) return null;

  return createPortal(children, container);
};
